import React from 'react'
import Select, { ActionMeta, GroupTypeBase, StylesConfig } from 'react-select'
import styled from 'styled-components'
import { OptionType } from '../../../types/utilities'
import Tooltip from '../../GeneralTextInput/Tooltip'
import { Title, Header, Asterisk, DivMain, DivIcon, Icon, DropdownIndicator, Placeholder } from '../BooleanList/styles'
import { NoOptionsMessage, Option, MenuList } from './customSelectStyle'

interface CustomSelectProps {
    value?: OptionType | OptionType[]
    title?: string
    editMode: boolean
    required?: boolean
    tooltip?: string
    tooltipMaxWidth?: string
    placeholder?: string
    isMultiple?: boolean
    isClearable?: boolean
    isSearchable?: boolean
    options: OptionType[]
    closeMenuOnSelect?: boolean
    showSelectedOnControl?:boolean
    onChange: (option: OptionType | OptionType[], actionMeta: ActionMeta<OptionType>) => void
}
const CustomSelect = ({
    onChange,
    title,
    value,
    editMode,
    required = true,
    tooltip = '',
    tooltipMaxWidth,
    options,
    placeholder = '---',
    closeMenuOnSelect,
    isMultiple = false,
    isClearable = true,
    isSearchable = false,
    showSelectedOnControl=true
}: CustomSelectProps): JSX.Element => {
    return (
        <StyledDivMain tabIndex={0} disabled={editMode}>
            <Header>
                <Title>{title}</Title>
                {tooltip ? (
                    <DivIcon>
                        <Tooltip 
                            className={'inputBoolean_tooltip'} 
                            text={tooltip}
                            maxWidth={tooltipMaxWidth}
                        />
                        <Icon className={'far fa-info-circle'} />
                    </DivIcon>
                ) : null}
                {required ? <Asterisk>*</Asterisk> : null}
            </Header>
            <div>
                <Select
                    options={options}
                    placeholder={placeholder}
                    onChange={onChange}
                    isDisabled={!editMode}
                    value={value}
                    controlShouldRenderValue={showSelectedOnControl}
                    styles={CustomListAsyncStyles}
                    components={{ DropdownIndicator, Placeholder, NoOptionsMessage, Option, MenuList }}
                    isSearchable={isSearchable}
                    isClearable={isClearable}
                    isMulti={isMultiple}
                    hideSelectedOptions={!isMultiple}
                    closeMenuOnSelect={closeMenuOnSelect}
                    // menuIsOpen={true}
                    filterOption={(option, input) => {
                        return (
                            option.label.includes(input) || // try to find full input
                            input.split(/[\s\t]+/g) //try to find splited splited
                                .filter(w => !!w.trim())
                                .find(w => option.label.includes(w)) !== undefined)
                    }}
                />
            </div>

        </StyledDivMain>
    )
}

export default CustomSelect

const StyledDivMain = styled(DivMain)`
    border: none;
    background-color: inherit;
    &:focus-within {
        background-color: inherit;
    }
    &:focus {
        background-color: inherit;
    }
`
//TODO: RETEST THIS STYLES AND FIX THE SIZE OF THE CONTROL/VALUE CONTAINER
const CustomListAsyncStyles: StylesConfig<OptionType, boolean, GroupTypeBase<OptionType>> = {
    container: styles => ({
        ...styles,
        borderRadius: '3px !important',
        borderStyle: 'none !important',
        // height: '32px ',
        // minHeight: '32px',
        // maxHeight: '32px '
    }),
    option: (styles, {isFocused, theme}) => ({
        ...styles,
        fontStyle: 'normal',
        fontWeight: 'normal',
        lineHeight: '14px ',
        fontSize: '14px ',
        color: 'black',
        backgroundColor: !isFocused ? null : theme.colors.primary25
    }),
    control: styles => ({
        ...styles,
        border: '1px solid #C8CCD4 !important',
        overflow: 'auto',
        borderRadius: '3px !important',
        height: 'auto '
    }),
    valueContainer: styles => ({
        ...styles,
        width: 'auto',
        height: '32px ',
        minHeight: '32px',
        maxHeight: '32px '
    }),
    indicatorSeparator: styles => ({
        ...styles,
        display: 'none '
    }),
    placeholder: styles => ({
        ...styles,
        position: 'absolute',
        top: '50%'
    }),
    menu: styles => ({
        ...styles,
        margin: '0px',
        borderRadius: '0px'
    })
}
